import { render } from "./TagFilter.vue?vue&type=template&id=290e4db7&scoped=true"
import script from "./TagFilter.vue?vue&type=script&lang=js"
export * from "./TagFilter.vue?vue&type=script&lang=js"

import "./TagFilter.vue?vue&type=style&index=0&id=290e4db7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290e4db7"]])

export default __exports__